<div class="alert-message-icon {{icon}}">
    <h3 ><span [innerHtml]="text">{{text}}</span></h3>
</div>
